import { API } from "config";
import * as types from "types";
import request from "utilities/request";

const baseUrl = API.dbApi.url;

interface DeleteThreadResponseBody {
  id: types.ChatThread["id"];
}

/**
 * Deletes a chat thread (including its messages).
 *
 * Resolves to `{ id: threadId }` on success. The id is echoed from the
 * caller's input rather than parsed from the response body — corteva-chat-api
 * returns 204 No Content with an empty body, while corteva-chat-db-api
 * returns 200 with a JSON body. We tolerate both by ignoring the body
 * entirely; `request` already throws on non-2xx, so reaching this point
 * means the server confirmed the delete.
 */
export async function deleteThread(
  threadId: string,
  getAccessToken: () => Promise<string>
): Promise<DeleteThreadResponseBody> {
  const accessToken = await getAccessToken();

  const url = `${baseUrl}/threads/${threadId}`;
  const headers = { Authorization: `Bearer ${accessToken}` };
  const options = { method: "DELETE", headers };

  await request(url, options);
  return { id: threadId };
}
